var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4153 12.8416C7.83636 12.8383 5.36399 11.8123 3.5404 9.9887C1.71681 8.1651 0.690843 5.69274 0.6875 3.11379C0.6875 2.34315 0.993636 1.60407 1.53856 1.05914C2.08349 0.514216 2.82257 0.20808 3.59321 0.20808C3.7564 0.206837 3.91931 0.221647 4.0796 0.252297C4.23456 0.275227 4.38689 0.313311 4.53441 0.365999C4.63816 0.402402 4.73061 0.465256 4.80262 0.548346C4.87463 0.631436 4.92371 0.731884 4.94499 0.839756L5.81039 4.62981C5.83372 4.73269 5.83091 4.83977 5.80222 4.94128C5.77353 5.04279 5.71988 5.1355 5.64616 5.21095C5.56404 5.29939 5.55772 5.3057 4.78076 5.70998C5.40296 7.07494 6.49462 8.17109 7.85702 8.79887C8.26761 8.01559 8.27393 8.00928 8.36236 7.92716C8.43781 7.85344 8.53052 7.79978 8.63203 7.77109C8.73355 7.74241 8.84063 7.7396 8.9435 7.76292L12.7336 8.62832C12.838 8.65255 12.9345 8.70295 13.0141 8.77478C13.0936 8.84661 13.1536 8.9375 13.1884 9.03891C13.2417 9.18884 13.2818 9.34313 13.3084 9.50003C13.3338 9.65879 13.3465 9.81933 13.3463 9.98011C13.3346 10.7475 13.0199 11.479 12.4708 12.0151C11.9216 12.5513 11.1827 12.8484 10.4153 12.8416Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlack);
export default __webpack_public_path__ + "static/media/phone-black.c5750440691cbed6311b3340a31b57a4.svg";
export { ForwardRef as ReactComponent };